
import { defineComponent, ref, reactive, toRefs, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import axios from '../../../../axios' 
import TransactionHistory from './TransactionHistory.vue'

export default defineComponent({
    components: {
        TransactionHistory
    },
    setup () {
        const store = useStore()
        const fields = ref<any>([
            {
                title: 'Business Unit Name',
                dataIndex: 'site.name',
                width: 150,
                fixed: 'left'
            },
            {
                title: 'Bank Name',
                dataIndex: 'bank_name',
                width: 150,
                fixed: 'left'
            },
            {
                title: 'Bank Account',
                dataIndex: 'bank_account_name',
                width: 150,
                fixed: 'left'
            },
            {
                title: 'Payee',
                dataIndex: 'payee',
                width: 150,
            },
            {
                title: 'Payment Date',
                dataIndex: 'payment_date',
                width: 100,
            },
            {
                title: 'Due Date',
                dataIndex: 'due_date',
                width: 100,
            },
            {
                title: 'Payment Status',
                dataIndex: 'payment_status',
                width: 100,
            },
            {
                title: 'Payment Method',
                dataIndex: 'payment_mode.name',
                width: 100,
            },
            {
                title: 'Payment Voucher Number',
                dataIndex: 'pv_number',
                width: 100,
            },
            {
                title: 'APV Number',
                dataIndex: 'apv_number',
                width: 100,
            },
            {
                title: 'Identifying PO',
                dataIndex: 'identifying_po',
                width: 100,
            },
            {
                title: 'Currency',
                dataIndex: 'currency',
                width: 100,
            },
            {
                title: 'Invoice Accounting Date',
                dataIndex: 'invoice_accounting_date',
                width: 100,
            },
            {
                title: 'Invoice Number',
                dataIndex: 'invoice_number',
                width: 100,
            },
            {
                title: 'Invoice Amount',
                dataIndex: 'invoice_amount',
                width: 100,
            },
            {
                title: 'Total Tax Charged',
                dataIndex: 'total_tax_charged',
                width: 100,
            },
            {
                title: 'Withheld Amount In Entered Currency',
                dataIndex: 'withheld_amount_in_entered_currency',
                width: 100,
            },
            {
                title: 'Invoice Amount Paid',
                dataIndex: 'invoice_amount_paid',
                width: 100,
            },
            {
                title: 'Invoice Description',
                dataIndex: 'invoice_description',
                width: 200,
                ellipsis: true,
            },
            {
                title: 'Trans. Number',
                dataIndex: 'ibps_transaction_number',
                width: 100,
            },
            {
                title: 'Status',
                dataIndex: 'check_status.name',
                width: 100,
            },
            {
                title: 'Releasing Site',
                dataIndex: 'releasing_site',
                width: 100,
            },
            {
                title: 'Releasing Date',
                dataIndex: 'releasing_date',
                width: 100,
            },
            {
                title: 'OR Date',
                dataIndex: 'or_date',
                width: 100,
            },
            {
                title: 'OR No.',
                dataIndex: 'or_number',
                width: 100,
            },
            {
                title: 'Payment Created By',
                dataIndex: 'payment_created_by',
                width: 150,
            },
            {
                title: 'Requester',
                dataIndex: 'requester',
                width: 150,
            },
            {
                title: 'Action',
                dataIndex: 'action',
                slots: {customRender: 'action'},
                align: 'center',
                width: 150,
            }
        ])

        // const form = reactive({
        //     name: '',
        //     code: '',
        //     branch: '',
        //     address: '',
        //     description: '',
        // })

        const visible = ref(false)
        

        const index = (payload = {page: 1}) => {
            store.dispatch('CoalPayment/index', payload)
        }

        const filterRecord = (payload: any) => {
            index(payload)
        }

        onMounted(index)

        const items = computed(() => store.getters['CoalPayment/items'])
        const loading = computed(() => store.getters['CoalPayment/status'])
        var transactionHistory: { datetime: string; action_name: string; check_status: string; entry_date_time: string; exit_date_time: string; }[] = [];

        const showRecord = (record:any) => {
            transactionHistory.length = 0;
            const transaction_histories = record.transaction_history;
            transaction_histories.forEach((element:any) => {
                transactionHistory.push({
                    datetime: element.datetime,
                    action_name: element.action_name,
                    check_status: element.check_status_name,
                    entry_date_time: element.entry_date_time,
                    exit_date_time: element.exit_date_time
                });
            });
            console.log(transactionHistory)
            visible.value = true
        }

        return {
            fields,
            loading,
            items,
            filterRecord,
            visible,
            showRecord,
            transactionHistory
        }

    }
})
